import { type PropsWithChildren, useEffect, useState } from "react";
import { Image } from "react-native";
import { View as ViewV2 } from "~/components/V2/View";

export const WithSplashScreen = ({
  isAppReady,
  children,
}: PropsWithChildren<{
  isAppReady: boolean;
}>) => {
  const HIDDEN = "hidden";
  const VISIBLE = "visible";

  const [state, setState] = useState(HIDDEN);

  const imageWidth = 155.8;
  const aspectRatio = 3116 / 1479;
  const imageHeight = imageWidth / aspectRatio;

  useEffect(() => {
    if (isAppReady) {
      setTimeout(() => {
        setState(VISIBLE);
      }, 500);
    }
  }, [isAppReady]);

  if (state === VISIBLE) {
    return children;
  }

  return (
    <ViewV2 flex centerContent colorPrimary>
      <Image
        source={require("~/features/splash/evidensia-logo.png")}
        style={{ width: imageWidth, height: imageHeight }}
      />
    </ViewV2>
  );
};
